import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import Card from '../../core/components/Card'
import Icon from '../../core/components/Icon'
import {DEFAULT_TICKET_QUERY, queryMinorTicketStream} from '../actions'
import i18n from '../i18n'
import style from './TicketStreamCard.less'

class TicketStreamCard extends Component {
    static propTypes = {
        patrimony: PropTypes.object,
        callPurpose: PropTypes.string,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, patrimony, callPurpose} = this.props
        dispatch(queryMinorTicketStream({...DEFAULT_TICKET_QUERY, patrimony: patrimony.uid, callPurpose, status: 'OPENED'}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.patrimony != this.props.patrimony
            || nextProps.callPurpose != this.props.callPurpose) {
            const {dispatch, patrimony, callPurpose} = nextProps

            dispatch(queryMinorTicketStream({...DEFAULT_TICKET_QUERY, patrimony: patrimony.uid, callPurpose, status: 'OPENED'}))
        }
    }

    _navigate(event, ticket) {
        const {dispatch} = this.props

        event.preventDefault()

        if (event.ctrlKey || event.metaKey) {
            window.open('/tickets/' + ticket.uid, '_blank')
        } else {
            dispatch(push('/tickets/' + ticket.uid))
        }
    }

    render() {
        const {dispatch, stream, range, patrimony, callPurpose, onSubmit, ...others} = this.props

        const header = (
            <h3>{i18n.existingTickets}</h3>
        )

        const tooltip = (text) => {
            return (
                <Tooltip className='tooltip-success'>
                    {text}
                </Tooltip>
            )
        }

        return (
            <Card
                header={header}
                {...others}>
                <div className={style.default}>
                    <ul>
                        {stream.map((ticket, index) => (
                            <li
                                key={index}>
                                <OverlayTrigger
                                    placement='bottom'
                                    overlay={tooltip(i18n.receiveCallz)}>
                                    <Button
                                        bsStyle='link'
                                        onClick={(e) => onSubmit(e, 'ReceiveCall', ticket)}>
                                        <Icon active icon='phone' size='xs' />
                                    </Button>
                                </OverlayTrigger>
                                <div className={style.container}>
                                    <a
                                        href=''
                                        onClick={(e) => this._navigate(e, ticket)}>
                                        <span>{ticket.ref}</span>
                                    </a>
                                    <strong>{ticket.openingTicketPurpose.callPurpose}</strong>
                                    <small>{ticket.request}</small>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </Card>
        )
    }
}

TicketStreamCard = connect((state) => ({
    stream: state.ticket.minorStream,
    range: state.ticket.minorRange
}))(TicketStreamCard)

export default TicketStreamCard


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketStreamCard.js